// extracted by mini-css-extract-plugin
export default {"sidebar_item":"SidebarItem_sidebar_item__5cyca","texto_link":"SidebarItem_texto_link__LhetI","link_ativo":"SidebarItem_link_ativo__CIKmd"};